import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["description", "tagsContainer", "saveButton", "suggestButton"]
  static values = {
    updateUrl: String,
    suggestUrl: String,
    frameUrl: String,
    redirectUrl: String
  }

  suggest() {
    const desc = this.descriptionTarget.value
    if (!desc.trim()) return

    const btn = this.suggestButtonTarget
    btn.disabled = true
    btn.innerHTML = '<span class="fas fa-spinner fa-spin mr-1"></span> Matching...'

    const csrf = document.querySelector('meta[name="csrf-token"]').content
    fetch(this.suggestUrlValue, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
      body: JSON.stringify({ description: desc })
    })
    .then(r => r.json())
    .then(data => {
      if (data.roles && data.roles.length > 0) {
        // Save the suggested roles
        return fetch(this.updateUrlValue, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
          body: JSON.stringify({ roles: data.roles, work_description: desc })
        })
      }
    })
    .then(() => {
      this.afterSave()
    })
    .catch(() => {
      btn.disabled = false
      btn.innerHTML = '<span class="far fa-sparkles mr-1"></span> Get Recommendations'
    })
  }

  save(event) {
    event.preventDefault()

    const form = this.element.querySelector('#role-setup-form') || this.element
    const roles = Array.from(form.querySelectorAll('input[name="roles[]"]:checked'))
      .map(el => el.value)

    const btn = event.currentTarget
    btn.disabled = true
    btn.textContent = 'Saving...'

    const csrf = document.querySelector('meta[name="csrf-token"]').content
    fetch(this.updateUrlValue, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
      body: JSON.stringify({ roles: roles, work_description: this.hasDescriptionTarget ? this.descriptionTarget.value : '' })
    }).then(() => {
      this.afterSave()
    })
  }

  afterSave() {
    if (this.hasRedirectUrlValue && this.redirectUrlValue) {
      window.location.href = this.redirectUrlValue
      return
    }

    const modal = document.getElementById('aiTaskModal')
    if (modal && typeof $ !== 'undefined') $(modal).modal('hide')

    const frame = document.querySelector('turbo-frame#favorited-tasks-frame')
    if (frame) {
      frame.src = this.frameUrlValue
      frame.reload()
    } else {
      window.location.reload()
    }
  }

  filter(event) {
    const q = event.target.value.toLowerCase()
    const items = this.element.querySelectorAll('.role-tag-item')
    const tagsContainer = this.element.querySelector('.role-tags-container')

    items.forEach(item => {
      item.style.display = (q === '' || item.dataset.role.indexOf(q) !== -1) ? '' : 'none'
    })

    if (q !== '') {
      tagsContainer.classList.remove('role-tags-collapsed')
    } else {
      tagsContainer.classList.add('role-tags-collapsed')
    }
  }

  toggleMore(event) {
    const tagsContainer = this.element.querySelector('.role-tags-container')
    tagsContainer.classList.toggle('role-tags-collapsed')
    const collapsed = tagsContainer.classList.contains('role-tags-collapsed')
    const btn = event.currentTarget
    btn.querySelector('span:last-child').textContent = collapsed ? 'Show More' : 'Show Less'
    btn.querySelector('i').classList.toggle('fa-chevron-down', collapsed)
    btn.querySelector('i').classList.toggle('fa-chevron-up', !collapsed)
  }
}
